import { Heart, Instagram, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF7F2] font-body">
      <div className="max-w-2xl mx-auto px-4 py-12">
        {/* Back Link */}
        <Link 
          to="/pass" 
          className="inline-flex items-center gap-2 text-[#8B2332] hover:text-[#7A1E2B] mb-8 transition-colors"
          data-testid="back-to-pass-datenschutz"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Anmeldung
        </Link>

        <h1 className="font-heading text-4xl text-[#2D2D2D] mb-8">
          Datenschutzerklärung
        </h1>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-[#EFEBE5] space-y-6">
          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              1. Verantwortliche Stelle
            </h2>
            <div className="text-[#6B6B6B] space-y-1">
              <p>EDYT & BLOOM UG</p>
              <p>Steglitzer Damm 38</p>
              <p>12169 Berlin</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              2. Erhobene Daten
            </h2>
            <p className="text-[#6B6B6B] leading-relaxed text-sm">
              Bei der Anmeldung zum Newsletter erheben wir folgende Daten:
            </p>
            <ul className="text-[#6B6B6B] text-sm list-disc list-inside mt-2 space-y-1">
              <li>Name</li>
              <li>E-Mail-Adresse</li>
              <li>Einwilligung zur Datenverarbeitung</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              3. Zweck der Datenverarbeitung
            </h2>
            <p className="text-[#6B6B6B] leading-relaxed text-sm">
              Wir verwenden deine Daten ausschließlich, um dir Informationen zum 
              Hijab & Halal Pop-up Event zu senden, einschließlich:
            </p>
            <ul className="text-[#6B6B6B] text-sm list-disc list-inside mt-2 space-y-1">
              <li>Event-Updates und Erinnerungen</li>
              <li>Brand-Guide mit teilnehmenden Marken</li>
              <li>Exklusive Deals und Angebote</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              4. Newsletter-Dienst
            </h2>
            <p className="text-[#6B6B6B] leading-relaxed text-sm">
              Wir nutzen SendFox für den Versand unserer E-Mails. SendFox ist ein 
              Newsletter-Dienst, der die DSGVO-Anforderungen erfüllt. Weitere 
              Informationen findest du in der Datenschutzerklärung von SendFox.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              5. Deine Rechte
            </h2>
            <p className="text-[#6B6B6B] leading-relaxed text-sm">
              Du hast jederzeit das Recht:
            </p>
            <ul className="text-[#6B6B6B] text-sm list-disc list-inside mt-2 space-y-1">
              <li>Auskunft über deine gespeicherten Daten zu erhalten</li>
              <li>Die Berichtigung unrichtiger Daten zu verlangen</li>
              <li>Die Löschung deiner Daten zu verlangen</li>
              <li>Dich vom Newsletter abzumelden (Link in jeder E-Mail)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              6. Abmeldung
            </h2>
            <p className="text-[#6B6B6B] leading-relaxed text-sm">
              Du kannst dich jederzeit vom Newsletter abmelden. In jeder E-Mail 
              findest du einen Abmelde-Link. Nach der Abmeldung werden deine Daten 
              gelöscht.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              7. Kontakt
            </h2>
            <p className="text-[#6B6B6B] leading-relaxed text-sm">
              Bei Fragen zum Datenschutz erreichst du uns über Instagram: 
              <a 
                href="https://www.instagram.com/edytandbloom/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[#8B2332] hover:underline ml-1"
              >
                @edytandbloom
              </a>
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-4 bg-white border-t border-[#EFEBE5]">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2 text-[#6B6B6B]">
              <Heart className="w-4 h-4 text-[#8B2332]" />
              <span className="font-medium text-[#2D2D2D]">EDYT & BLOOM</span>
            </div>
            
            <div className="flex items-center gap-6 text-sm">
              <a 
                href="/impressum" 
                className="text-[#6B6B6B] hover:text-[#8B2332] transition-colors"
              >
                Impressum
              </a>
              <a 
                href="/datenschutz" 
                className="text-[#8B2332] font-medium"
              >
                Datenschutz
              </a>
              <a 
                href="https://www.instagram.com/edytandbloom/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#6B6B6B] hover:text-[#8B2332] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DatenschutzPage;
